import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      nav: {
        home: 'Inicio',
        apps: 'Apps',
        contact: 'Contacto'
      },
      hero: {
        title: 'Bienvenido a mi espacio',
        subtitle: 'On - IA - Golf',
        whatsapp: 'Contáctame por WhatsApp'
      },
      apps: {
        title: 'Apps for Caps',
        visit: 'Visitar Beta',
        clases: {
          title: 'Clases',
          description: 'Mi desarrollo para reservar clases de la Escuela de Iniciación al Golf'
        },
        reglas: {
          title: 'Reglas',
          description: 'App creada para Tests de Reglas de Golf y Consultas a un arbitro virtual'
        },
        mental: {
          title: 'Mental',
          description: 'Nos va a ir de maravilla esta App para entrenar tu mente y mejorar tu golf como ni te imaginas'
        },
        capflix: {
          title: 'Capflix',
          description: 'Plataforma de contenido audiovisual de golf ordenado por categorías y con sistema de valoración por el usuario'
        }
      },
      clubs: {
        title: 'Apps for Clubs',
        afterdark: {
          description: 'After Dark gestiona las luces de práctica nocturna en campos de golf. Los socios compran crédito y controlan las luces mediante switches inteligentes. Sistema con apagado automático a las 21:00h y panel de administración completo. Soporte bilingüe (Català/Español).'
        }
      },
      capsIntro: {
        title: 'Caps, generando golfistas',
        description: 'Caps es el programa de iniciación al golf que desde 2023 ha iniciado a 300 nuevos jugadores y un centenar ya son socios de Golf Lleida & Country Club.'
      },
      emergent: {
        text1: 'Descubre qué fácil es crear tus propias webs y apps con Emergent.',
        text2: 'Si necesitas una introducción cuenta conmigo.'
      },
      contact: {
        title: '¿En qué te puedo ayudar?',
        subtitle: 'Estoy aquí para responder tus preguntas sobre golf, formación o proyectos.',
        cardTitle: 'Envíame un mensaje',
        cardDescription: 'Completa el formulario y me pondré en contacto contigo lo antes posible.',
        name: 'Nombre',
        email: 'Email',
        subject: 'Asunto',
        message: 'Mensaje',
        namePlaceholder: 'Tu nombre completo',
        emailPlaceholder: 'tu@email.com',
        subjectPlaceholder: '¿De qué quieres hablar?',
        messagePlaceholder: 'Cuéntame en qué te puedo ayudar...',
        submitButton: 'Enviar mensaje',
        submitting: 'Enviando...',
        toastTitle: '¡Redirigiendo a WhatsApp!',
        toastDescription: 'Se abrirá WhatsApp con tu mensaje.'
      },
      footer: {
        quickLinks: 'Enlaces rápidos',
        follow: 'Sígueme',
        copyright: 'Todos los derechos reservados.'
      },
      whatsappMessage: {
        hero: 'Hola Joan, me gustaría contactar contigo.',
        form: '*Nuevo mensaje de contacto*\n\n*Nombre:* {name}\n*Email:* {email}\n*Asunto:* {subject}\n\n*Mensaje:*\n{message}',
        zonaPro: 'Hola Joan, me gustaría ver tu portfolio en la zona pro. Mi nombre y posición es '
      },
      h0: {
        brandName: 'Hoyo Zero',
        tagline: 'Tu puerta de entrada al golf',
        doors: {
          sig: '¿Quieres jugar tu primer hoyo de golf?',
          caps: '¿Eres un Caps de Lleida?',
          nuts: '¿Eres un Nuts de Andorra?',
          shark: '¿Hemos compartido green alguna vez?',
          quinta: '¿Eres de la Quinta?',
          about: 'Quién soy'
        },
        onIaGolfHint: 'Acceso al espacio On - IA - Golf',
        sigMessage: 'Hola Joan, quiero información sobre la SIG en UGOLF Aravell Andorra.',
        shopLabel: 'De compras por el mundo',
        shopHint: 'La tienda del Hoyo Zero · Amazon',
        videoLabel: 'Video'
      },
      nuts: {
        heroTitle: 'Bienvenido a los Nuts',
        heroSubtitle: 'La comunidad privada para los nuevos apasionados del golf en Andorra y l\'Alt Urgell.',
        tabRegister: 'Crear cuenta',
        tabLogin: 'Iniciar sesión',
        haveAccount: '¿Ya tienes cuenta? Iniciar sesión',
        noAccount: '¿Aún no tienes cuenta? Crear una',
        welcome: '¡Bienvenido a Nuts!',
        welcomeBack: '¡Bienvenido de nuevo!',
        submitting: 'Procesando...',
        logout: 'Cerrar sesión',
        hello: 'Hola, {{name}}',
        dashboardSubtitle: 'Tu espacio en la comunidad Nuts d\'Andorra',
        toolsTitle: 'Tus herramientas',
        recommended: 'Empieza aquí',
        open: 'Abrir',
        openSSO: 'Entrar con un clic',
        openingSSO: 'Conectando...',
        classesOpenError: 'No hemos podido abrir la app. Inténtalo de nuevo.',
        appOpenError: 'No hemos podido abrir {{app}}. Inténtalo de nuevo.',
        pinTitle: 'Tu PIN',
        pinTitleClasses: 'Tu PIN para Classes y Mental',
        pinTitleMental: 'Tu PIN para Mental',
        pinShow: 'Mostrar',
        pinHide: 'Ocultar',
        pinHint: 'Lo necesitas solo si entras manualmente. Desde aquí, accedes con un clic.',
        forumCardTitle: 'Foro de los Nuts',
        forumCardSubtitle: 'Salas, hilos y conversaciones con la comunidad.',
        specialsTitle: 'Especiales',
        specialsSubtitle: 'Pequeños extras solo para los Nuts.',
        specialsSoon: 'Pronto',
        specialsComingSoon: 'Muy pronto disponible para los Nuts ✨',
        soonTitle: 'Próximamente',
        soonText: 'Foro de la comunidad',
        soonDescription: 'Salas abiertas, hilos de conversación, propuestas mías y mucho más para construir juntos la comunidad Nuts.',
        form: {
          email: 'Email',
          password: 'Contraseña',
          passwordHelp: 'Mínimo 8 caracteres',
          nickname: 'Nickname',
          nicknameHelp: 'Visible para los demás',
          chooseAvatar: 'Elige tu avatar',
          fullName: 'Nombre',
          surnames: 'Apellidos',
          mobile: 'Móvil',
          privateHelp: 'Privado · solo lo ve Joan',
          createAccount: 'Crear mi cuenta',
          signIn: 'Entrar'
        },
        errors: {
          pickAvatar: 'Elige un avatar para continuar',
          generic: 'Algo ha fallado. Inténtalo de nuevo.'
        },
        backToDashboard: 'Nuts'
      },
      forum: {
        eyebrow: 'FORO NUTS',
        title: 'El foro de los Nuts',
        subtitle: 'Salas, hilos y momentos compartidos.',
        threads: 'hilos',
        replies: 'respuestas',
        noRooms: 'Aún no hay salas.',
        noThreads: 'Aún no hay hilos. Sé el primero 🥜',
        newThread: 'Abrir nuevo hilo',
        threadTitlePlaceholder: 'Título del hilo',
        threadBodyPlaceholder: '¿Qué quieres compartir?',
        threadCreated: 'Hilo publicado',
        publishing: 'Publicando...',
        publish: 'Publicar',
        cancel: 'Cancelar',
        shortContent: 'Título demasiado corto o cuerpo vacío',
        genericError: 'Algo ha fallado',
        replyPlaceholder: 'Escribe tu respuesta...',
        imageUrlPlaceholder: 'URL de imagen (opcional, ej: Cloudinary)',
        posting: 'Enviando...',
        reply: 'Responder',
        roomSubtitle: 'Conversa con los Nuts',
        allRooms: 'Todas las salas',
        backToRoom: 'Foro',
        threadNotFound: 'Hilo no encontrado',
        confirmDelete: '¿Borrar este comentario?'
      }
    }
  },
  ca: {
    translation: {
      nav: {
        home: 'Inici',
        apps: 'Apps',
        contact: 'Contacte'
      },
      hero: {
        title: 'Benvingut al meu espai',
        subtitle: 'On - IA - Golf',
        whatsapp: 'Contacta\'m per WhatsApp'
      },
      apps: {
        title: 'Apps for Caps',
        visit: 'Visitar Beta',
        clases: {
          title: 'Classes',
          description: 'El meu desenvolupament per reservar classes de l\'Escola d\'Iniciació al Golf'
        },
        reglas: {
          title: 'Regles',
          description: 'App creada per a Tests de Regles de Golf i Consultes a un àrbitre virtual'
        },
        mental: {
          title: 'Mental',
          description: 'Ens anirà de meravella aquesta App per entrenar la teva ment i millorar el teu golf com ni t\'imagines'
        },
        capflix: {
          title: 'Capflix',
          description: 'Plataforma de contingut audiovisual de golf ordenat per categories i amb sistema de valoració per l\'usuari'
        }
      },
      clubs: {
        title: 'Apps for Clubs',
        afterdark: {
          description: 'After Dark gestiona els llums de pràctica nocturna en camps de golf. Els socis compren crèdit i controlen els llums mitjançant switches intel·ligents. Sistema amb apagat automàtic a les 21:00h i panell d\'administració complet. Suport bilingüe (Català/Español).'
        }
      },
      capsIntro: {
        title: 'Caps, generant golfistes',
        description: 'Caps és el programa d\'iniciació al golf que des del 2023 ha iniciat a 300 nous jugadors i un centenar ja són socis del Golf Lleida & Country Club.'
      },
      emergent: {
        text1: 'Descobreix què fàcil és crear les teves pròpies webs i apps amb Emergent.',
        text2: 'Si necessites una introducció compta amb mi.'
      },
      contact: {
        title: 'En què et puc ajudar?',
        subtitle: 'Estic aquí per respondre les teves preguntes sobre golf, formació o projectes.',
        cardTitle: 'Envia\'m un missatge',
        cardDescription: 'Completa el formulari i em posaré en contacte amb tu el més aviat possible.',
        name: 'Nom',
        email: 'Email',
        subject: 'Assumpte',
        message: 'Missatge',
        namePlaceholder: 'El teu nom complet',
        emailPlaceholder: 'el.teu@email.com',
        subjectPlaceholder: 'De què vols parlar?',
        messagePlaceholder: 'Explica\'m en què et puc ajudar...',
        submitButton: 'Enviar missatge',
        submitting: 'Enviant...',
        toastTitle: 'Redirigint a WhatsApp!',
        toastDescription: 'S\'obrirà WhatsApp amb el teu missatge.'
      },
      footer: {
        quickLinks: 'Enllaços ràpids',
        follow: 'Segueix-me',
        copyright: 'Tots els drets reservats.'
      },
      whatsappMessage: {
        hero: 'Hola Joan, m\'agradaria contactar amb tu.',
        form: '*Nou missatge de contacte*\n\n*Nom:* {name}\n*Email:* {email}\n*Assumpte:* {subject}\n\n*Missatge:*\n{message}',
        zonaPro: 'Hola Joan, m\'agradaria veure el teu portfoli a la zona pro. El meu nom i posició és '
      },
      h0: {
        brandName: 'Forat Zero',
        tagline: 'La teva porta d\'entrada al golf',
        doors: {
          sig: 'Vols jugar el teu primer forat de golf?',
          caps: 'Ets un Caps de Lleida?',
          nuts: 'Ets un Nuts d\'Andorra?',
          shark: 'Ets un Shark?',
          quinta: 'Ets de la Quinta?',
          about: 'Qui sóc'
        },
        onIaGolfHint: 'Accés a l\'espai On - IA - Golf',
        sigMessage: 'Hola Joan, vull informació sobre la SIG a UGOLF Aravell Andorra.',
        shopLabel: 'De compres pel món',
        shopHint: 'La botiga del Forat Zero · Amazon',
        videoLabel: 'Vídeo'
      },
      nuts: {
        heroTitle: 'Benvingut als Nuts',
        heroSubtitle: 'La comunitat privada per als nous apassionats del golf a Andorra i l\'Alt Urgell.',
        tabRegister: 'Crear compte',
        tabLogin: 'Iniciar sessió',
        haveAccount: 'Ja tens compte? Iniciar sessió',
        noAccount: 'Encara no tens compte? Crear-ne un',
        welcome: 'Benvingut a Nuts!',
        welcomeBack: 'Benvingut de nou!',
        submitting: 'Processant...',
        logout: 'Tancar sessió',
        hello: 'Hola, {{name}}',
        dashboardSubtitle: 'El teu espai a la comunitat Nuts d\'Andorra',
        toolsTitle: 'Les teves eines',
        recommended: 'Comença aquí',
        open: 'Obrir',
        openSSO: 'Entrar amb un clic',
        openingSSO: 'Connectant...',
        classesOpenError: 'No hem pogut obrir l\'app. Torna-ho a provar.',
        appOpenError: 'No hem pogut obrir {{app}}. Torna-ho a provar.',
        pinTitle: 'El teu PIN',
        pinTitleClasses: 'El teu PIN per Classes i Mental',
        pinTitleMental: 'El teu PIN per Mental',
        pinShow: 'Mostrar',
        pinHide: 'Amagar',
        pinHint: 'El necessites només si entres manualment. Des d\'aquí, accedeixes amb un clic.',
        forumCardTitle: 'Fòrum dels Nuts',
        forumCardSubtitle: 'Sales, fils i converses amb la comunitat.',
        specialsTitle: 'Especials',
        specialsSubtitle: 'Petits extres només pels Nuts.',
        specialsSoon: 'Aviat',
        specialsComingSoon: 'Molt aviat disponible pels Nuts ✨',
        soonTitle: 'Aviat',
        soonText: 'Fòrum de la comunitat',
        soonDescription: 'Sales obertes, fils de conversa, propostes meves i molt més per construir junts la comunitat Nuts.',
        form: {
          email: 'Email',
          password: 'Contrasenya',
          passwordHelp: 'Mínim 8 caràcters',
          nickname: 'Nickname',
          nicknameHelp: 'Visible per als altres',
          chooseAvatar: 'Tria el teu avatar',
          fullName: 'Nom',
          surnames: 'Cognoms',
          mobile: 'Mòbil',
          privateHelp: 'Privat · només el veu Joan',
          createAccount: 'Crear el meu compte',
          signIn: 'Entrar'
        },
        errors: {
          pickAvatar: 'Tria un avatar per continuar',
          generic: 'Alguna cosa ha fallat. Torna-ho a provar.'
        },
        backToDashboard: 'Nuts'
      },
      forum: {
        eyebrow: 'FÒRUM NUTS',
        title: 'El fòrum dels Nuts',
        subtitle: 'Sales, fils i moments compartits.',
        threads: 'fils',
        replies: 'respostes',
        noRooms: 'Encara no hi ha sales.',
        noThreads: 'Encara no hi ha cap fil. Sigues el primer 🥜',
        newThread: 'Obrir un nou fil',
        threadTitlePlaceholder: 'Títol del fil',
        threadBodyPlaceholder: 'Què vols compartir?',
        threadCreated: 'Fil publicat',
        publishing: 'Publicant...',
        publish: 'Publicar',
        cancel: 'Cancel·lar',
        shortContent: 'Títol massa curt o cos buit',
        genericError: 'Alguna cosa ha fallat',
        replyPlaceholder: 'Escriu la teva resposta...',
        imageUrlPlaceholder: 'URL d\'imatge (opcional, ex: Cloudinary)',
        posting: 'Enviant...',
        reply: 'Respondre',
        roomSubtitle: 'Conversa amb els Nuts',
        allRooms: 'Totes les sales',
        backToRoom: 'Fòrum',
        threadNotFound: 'Fil no trobat',
        confirmDelete: 'Esborrar aquest comentari?'
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        apps: 'Apps',
        contact: 'Contact'
      },
      hero: {
        title: 'Welcome to my space',
        subtitle: 'On - AI - Golf',
        whatsapp: 'Contact me on WhatsApp'
      },
      apps: {
        title: 'Apps for Caps',
        visit: 'Visit Beta',
        clases: {
          title: 'Classes',
          description: 'My development to book classes at the Golf Initiation School'
        },
        reglas: {
          title: 'Rules',
          description: 'App created for Golf Rules Tests and Consultations with a virtual referee'
        },
        mental: {
          title: 'Mental',
          description: 'This App will be wonderful to train your mind and improve your golf like you can\'t imagine'
        },
        capflix: {
          title: 'Capflix',
          description: 'Golf audiovisual content platform organized by categories with user rating system'
        }
      },
      clubs: {
        title: 'Apps for Clubs',
        afterdark: {
          description: 'After Dark manages practice lights for night golf. Members purchase credits and control lights via smart switches. System with automatic shutdown at 9:00 PM and complete admin panel. Bilingual support (Catalan/Spanish).'
        }
      },
      capsIntro: {
        title: 'Caps, creating golfers',
        description: 'Caps is the golf initiation program that since 2023 has introduced 300 new players and a hundred are already members of Golf Lleida & Country Club.'
      },
      emergent: {
        text1: 'Discover how easy it is to create your own websites and apps with Emergent.',
        text2: 'If you need an introduction, count on me.'
      },
      contact: {
        title: 'How can I help you?',
        subtitle: 'I\'m here to answer your questions about golf, training or projects.',
        cardTitle: 'Send me a message',
        cardDescription: 'Fill out the form and I\'ll get back to you as soon as possible.',
        name: 'Name',
        email: 'Email',
        subject: 'Subject',
        message: 'Message',
        namePlaceholder: 'Your full name',
        emailPlaceholder: 'your@email.com',
        subjectPlaceholder: 'What do you want to talk about?',
        messagePlaceholder: 'Tell me how I can help you...',
        submitButton: 'Send message',
        submitting: 'Sending...',
        toastTitle: 'Redirecting to WhatsApp!',
        toastDescription: 'WhatsApp will open with your message.'
      },
      footer: {
        quickLinks: 'Quick Links',
        follow: 'Follow me',
        copyright: 'All rights reserved.'
      },
      whatsappMessage: {
        hero: 'Hi Joan, I would like to contact you.',
        form: '*New contact message*\n\n*Name:* {name}\n*Email:* {email}\n*Subject:* {subject}\n\n*Message:*\n{message}',
        zonaPro: 'Hi Joan, I would like to see your portfolio in the pro zone. My name and position is '
      },
      h0: {
        brandName: 'Hole Zero',
        tagline: 'Your gateway to golf',
        doors: {
          sig: 'Want to play your first hole of golf?',
          caps: 'Are you a Caps from Lleida?',
          nuts: 'Are you a Nuts from Andorra?',
          shark: 'Are you a Shark?',
          quinta: 'Are you a Quinta?',
          about: 'Who I am'
        },
        onIaGolfHint: 'Enter the On - IA - Golf space',
        sigMessage: 'Hi Joan, I would like info about the SIG at UGOLF Aravell Andorra.',
        shopLabel: 'Shopping around the world',
        shopHint: 'Hole Zero Shop · Amazon',
        videoLabel: 'Video'
      },
      nuts: {
        heroTitle: 'Welcome to the Nuts',
        heroSubtitle: 'The private community for new golf lovers in Andorra and l\'Alt Urgell.',
        tabRegister: 'Create account',
        tabLogin: 'Sign in',
        haveAccount: 'Already have an account? Sign in',
        noAccount: 'No account yet? Create one',
        welcome: 'Welcome to Nuts!',
        welcomeBack: 'Welcome back!',
        submitting: 'Processing...',
        logout: 'Sign out',
        hello: 'Hello, {{name}}',
        dashboardSubtitle: 'Your space in the Nuts d\'Andorra community',
        toolsTitle: 'Your tools',
        recommended: 'Start here',
        open: 'Open',
        openSSO: 'Enter with one click',
        openingSSO: 'Connecting...',
        classesOpenError: 'We could not open the app. Please try again.',
        appOpenError: 'We could not open {{app}}. Please try again.',
        pinTitle: 'Your PIN',
        pinTitleClasses: 'Your PIN for Classes and Mental',
        pinTitleMental: 'Your PIN for Mental',
        pinShow: 'Show',
        pinHide: 'Hide',
        pinHint: 'You only need it if you enter manually. From here, one-click access.',
        forumCardTitle: 'Nuts forum',
        forumCardSubtitle: 'Rooms, threads and conversations with the community.',
        specialsTitle: 'Specials',
        specialsSubtitle: 'Little extras just for the Nuts.',
        specialsSoon: 'Soon',
        specialsComingSoon: 'Coming very soon for the Nuts ✨',
        soonTitle: 'Coming soon',
        soonText: 'Community forum',
        soonDescription: 'Open rooms, conversation threads, my proposals and much more to build the Nuts community together.',
        form: {
          email: 'Email',
          password: 'Password',
          passwordHelp: 'Minimum 8 characters',
          nickname: 'Nickname',
          nicknameHelp: 'Visible to others',
          chooseAvatar: 'Choose your avatar',
          fullName: 'First name',
          surnames: 'Surnames',
          mobile: 'Mobile',
          privateHelp: 'Private · only Joan sees it',
          createAccount: 'Create my account',
          signIn: 'Sign in'
        },
        errors: {
          pickAvatar: 'Pick an avatar to continue',
          generic: 'Something went wrong. Please try again.'
        },
        backToDashboard: 'Nuts'
      },
      forum: {
        eyebrow: 'NUTS FORUM',
        title: 'The Nuts forum',
        subtitle: 'Rooms, threads and shared moments.',
        threads: 'threads',
        replies: 'replies',
        noRooms: 'No rooms yet.',
        noThreads: 'No threads yet. Be the first 🥜',
        newThread: 'Start a new thread',
        threadTitlePlaceholder: 'Thread title',
        threadBodyPlaceholder: 'What do you want to share?',
        threadCreated: 'Thread published',
        publishing: 'Publishing...',
        publish: 'Publish',
        cancel: 'Cancel',
        shortContent: 'Title too short or body empty',
        genericError: 'Something went wrong',
        replyPlaceholder: 'Write your reply...',
        imageUrlPlaceholder: 'Image URL (optional, e.g. Cloudinary)',
        posting: 'Sending...',
        reply: 'Reply',
        roomSubtitle: 'Chat with the Nuts',
        allRooms: 'All rooms',
        backToRoom: 'Forum',
        threadNotFound: 'Thread not found',
        confirmDelete: 'Delete this comment?'
      }
    }
  },
  fr: {
    translation: {
      nav: {
        home: 'Accueil',
        apps: 'Apps',
        contact: 'Contact'
      },
      hero: {
        title: 'Bienvenue dans mon espace',
        subtitle: 'On - IA - Golf',
        whatsapp: 'Contactez-moi sur WhatsApp'
      },
      apps: {
        title: 'Apps for Caps',
        visit: 'Visiter Beta',
        clases: {
          title: 'Cours',
          description: 'Mon outil pour réserver des cours à l\'École d\'Initiation au Golf'
        },
        reglas: {
          title: 'Règles',
          description: 'App créée pour les Tests de Règles de Golf et les Consultations avec un arbitre virtuel'
        },
        mental: {
          title: 'Mental',
          description: 'Cette App va merveilleusement bien t\'aider à entraîner ton mental et améliorer ton golf'
        },
        capflix: {
          title: 'Capflix',
          description: 'Plateforme de contenu audiovisuel de golf organisé par catégories avec système d\'évaluation'
        }
      },
      clubs: {
        title: 'Apps for Clubs',
        afterdark: {
          description: 'After Dark gère les lumières d\'entraînement nocturne sur les terrains de golf. Les membres achètent des crédits et contrôlent les lumières via des interrupteurs intelligents.'
        }
      },
      capsIntro: {
        title: 'Caps, créer des golfeurs',
        description: 'Caps est le programme d\'initiation au golf qui depuis 2023 a initié 300 nouveaux joueurs et une centaine sont déjà membres du Golf Lleida & Country Club.'
      },
      emergent: {
        text1: 'Découvre comme il est facile de créer tes propres sites web et apps avec Emergent.',
        text2: 'Si tu as besoin d\'une introduction, compte sur moi.'
      },
      contact: {
        title: 'Comment puis-je vous aider?',
        subtitle: 'Je suis ici pour répondre à vos questions sur le golf, la formation ou les projets.',
        cardTitle: 'Envoyez-moi un message',
        cardDescription: 'Remplissez le formulaire et je vous recontacterai dès que possible.',
        name: 'Nom',
        email: 'Email',
        subject: 'Sujet',
        message: 'Message',
        namePlaceholder: 'Votre nom complet',
        emailPlaceholder: 'votre@email.com',
        subjectPlaceholder: 'De quoi voulez-vous parler?',
        messagePlaceholder: 'Dites-moi comment je peux vous aider...',
        submitButton: 'Envoyer le message',
        submitting: 'Envoi...',
        toastTitle: 'Redirection vers WhatsApp!',
        toastDescription: 'WhatsApp s\'ouvrira avec votre message.'
      },
      footer: {
        quickLinks: 'Liens rapides',
        follow: 'Suivez-moi',
        copyright: 'Tous droits réservés.'
      },
      whatsappMessage: {
        hero: 'Salut Joan, j\'aimerais te contacter.',
        form: '*Nouveau message de contact*\n\n*Nom:* {name}\n*Email:* {email}\n*Sujet:* {subject}\n\n*Message:*\n{message}',
        zonaPro: 'Salut Joan, j\'aimerais voir ton portfolio dans la zone pro. Mon nom et ma position sont '
      },
      h0: {
        brandName: 'Trou Zero',
        tagline: 'Ta porte d\'entrée vers le golf',
        doors: {
          sig: 'Veux-tu jouer ton premier trou de golf?',
          caps: 'Es-tu un Caps de Lleida?',
          nuts: 'Es-tu un Nuts d\'Andorre?',
          shark: 'Es-tu un Shark?',
          quinta: 'Es-tu de la Quinta?',
          about: 'Qui je suis'
        },
        onIaGolfHint: 'Entrer dans l\'espace On - IA - Golf',
        sigMessage: 'Salut Joan, j\'aimerais des infos sur le SIG à UGOLF Aravell Andorre.',
        shopLabel: 'Shopping autour du monde',
        shopHint: 'Boutique Trou Zero · Amazon',
        videoLabel: 'Vidéo'
      },
      nuts: {
        heroTitle: 'Bienvenue chez les Nuts',
        heroSubtitle: 'La communauté privée pour les nouveaux passionnés de golf en Andorre et l\'Alt Urgell.',
        tabRegister: 'Créer un compte',
        tabLogin: 'Se connecter',
        haveAccount: 'Tu as déjà un compte? Se connecter',
        noAccount: 'Pas encore de compte? En créer un',
        welcome: 'Bienvenue chez Nuts!',
        welcomeBack: 'Bon retour!',
        submitting: 'En cours...',
        logout: 'Déconnexion',
        hello: 'Salut, {{name}}',
        dashboardSubtitle: 'Ton espace dans la communauté Nuts d\'Andorre',
        toolsTitle: 'Tes outils',
        recommended: 'Commence ici',
        open: 'Ouvrir',
        openSSO: 'Entrer en un clic',
        openingSSO: 'Connexion...',
        classesOpenError: 'Impossible d\'ouvrir l\'app. Réessaie.',
        appOpenError: 'Impossible d\'ouvrir {{app}}. Réessaie.',
        pinTitle: 'Ton PIN',
        pinTitleClasses: 'Ton PIN pour Classes et Mental',
        pinTitleMental: 'Ton PIN pour Mental',
        pinShow: 'Afficher',
        pinHide: 'Masquer',
        pinHint: 'Tu en as besoin uniquement pour entrer manuellement. D\'ici, accès en un clic.',
        forumCardTitle: 'Forum des Nuts',
        forumCardSubtitle: 'Salons, fils et conversations avec la communauté.',
        specialsTitle: 'Spéciaux',
        specialsSubtitle: 'Petits extras réservés aux Nuts.',
        specialsSoon: 'Bientôt',
        specialsComingSoon: 'Bientôt disponible pour les Nuts ✨',
        soonTitle: 'Bientôt',
        soonText: 'Forum de la communauté',
        soonDescription: 'Salles ouvertes, fils de discussion, mes propositions et bien plus pour construire ensemble la communauté Nuts.',
        form: {
          email: 'Email',
          password: 'Mot de passe',
          passwordHelp: 'Minimum 8 caractères',
          nickname: 'Pseudo',
          nicknameHelp: 'Visible par les autres',
          chooseAvatar: 'Choisis ton avatar',
          fullName: 'Prénom',
          surnames: 'Nom de famille',
          mobile: 'Mobile',
          privateHelp: 'Privé · seul Joan le voit',
          createAccount: 'Créer mon compte',
          signIn: 'Entrer'
        },
        errors: {
          pickAvatar: 'Choisis un avatar pour continuer',
          generic: 'Quelque chose s\'est mal passé. Réessaie.'
        },
        backToDashboard: 'Nuts'
      },
      forum: {
        eyebrow: 'FORUM NUTS',
        title: 'Le forum des Nuts',
        subtitle: 'Salons, fils et moments partagés.',
        threads: 'fils',
        replies: 'réponses',
        noRooms: 'Aucun salon pour le moment.',
        noThreads: 'Aucun fil pour le moment. Sois le premier 🥜',
        newThread: 'Ouvrir un nouveau fil',
        threadTitlePlaceholder: 'Titre du fil',
        threadBodyPlaceholder: 'Que veux-tu partager?',
        threadCreated: 'Fil publié',
        publishing: 'Publication...',
        publish: 'Publier',
        cancel: 'Annuler',
        shortContent: 'Titre trop court ou corps vide',
        genericError: 'Quelque chose s\'est mal passé',
        replyPlaceholder: 'Écris ta réponse...',
        imageUrlPlaceholder: 'URL d\'image (optionnel, ex: Cloudinary)',
        posting: 'Envoi...',
        reply: 'Répondre',
        roomSubtitle: 'Discute avec les Nuts',
        allRooms: 'Tous les salons',
        backToRoom: 'Forum',
        threadNotFound: 'Fil introuvable',
        confirmDelete: 'Supprimer ce commentaire?'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ca',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
